import { render } from "./TeamSection.vue?vue&type=template&id=099b1d19&scoped=true"
import script from "./TeamSection.vue?vue&type=script&lang=js"
export * from "./TeamSection.vue?vue&type=script&lang=js"

import "./TeamSection.vue?vue&type=style&index=0&id=099b1d19&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099b1d19"]])

export default __exports__